import React from "react";
import PropTypes from "prop-types";
import {Form, Input, Select, DatePicker, Row, Col, Button} from "antd";

import "./GeneralInfoTab.css";
import moment from "moment";
import {
    getCompanyType,
    getIdType,
    getIndustryCode,
    getOccupationCode,
    getSourceOfFundCode
} from "../api/api";
import {displayGenericError} from "../common/notifications";
import BrdgxNationalitySelector from "./selector/BrdgxNationalitySelector";
import {getCountryList, getNationalityList} from "../api/api";
import BrdgxCountrySelector from "./selector/BrdgxCountrySelector";
import OccupationSelector from "./selector/OccupationSelector";
import IndustrySelector from "./selector/IndustrySelector";
import SourceOfFundsSelector from "./selector/SourceOfFundsSelector";
import CompanyTypeSelector from "./selector/CompanyTypeSelector";


class GeneralCorpInfoTab extends React.Component {
    state = {
        customerAccount: this.props.customerAccount,
        nationalities: [],
        industries: [],
        countries: [],
        sourceOfFunds:[],
        companyTypes:[]
    };

    componentDidMount() {
        // getCompanyType().then(response => {
        //     this.setState({
        //         companyTypes: response
        //     });
        // }).catch(error => {
        //     displayGenericError(error);
        // });
        // getSourceOfFundCode().then(response => {
        //     this.setState({
        //         sourceOfFunds: response
        //     });
        // }).catch(error => {
        //     displayGenericError(error);
        // });
        // getIndustryCode().then(response => {
        //     this.setState({
        //         industries: response
        //     });
        // }).catch(error => {
        //     displayGenericError(error);
        // });
        //
        // getCountryList()
        //     .then(response => {
        //         this.setState({
        //             countries: response
        //         });
        //     })
        //     .catch(error => {
        //         displayGenericError(error);
        //     });


    }

    onFormDataChanged = event => {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;
        let corporateAccountDetails = Object.assign(this.state.customerAccount.corporateAccountDetails, {[inputName]: inputValue});

        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {corporateAccountDetails: corporateAccountDetails}),

        });

    };
    onFieldChanged = (fieldName, newValue) => {
        let corporateAccountDetails = Object.assign(this.state.customerAccount.corporateAccountDetails, {[fieldName]: newValue});
        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {corporateAccountDetails: corporateAccountDetails}),

        }, () => {
        });

    };
    handleSubmit = () => {

        this.props.onSubmit(this.state.customerAccount);
    };

    render() {

        return (
            <div className="general-info-tab">
                <div className="left-pane">
                <Row gutter={16}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Name of Business *">
                            <Input   size={"large"}
                                value={this.state.customerAccount.corporateAccountDetails.nameOfBusiness}
                                name="nameOfBusiness"

                                onChange={this.onFormDataChanged}
                            />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Business Registration Number *">
                            <Input
                                size={"large"}
                                value={this.state.customerAccount.corporateAccountDetails.businessRegistrationNumber}
                                name="businessRegistrationNumber"
                                onChange={this.onFormDataChanged}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    {/*<Col className="gutter-row" span={12}>*/}
                    {/*    <Form.Item*/}
                    {/*        label="Source Of Funds *"*/}
                    {/*        required="true">*/}
                    {/*        <SourceOfFundsSelector*/}
                    {/*            sourceOfFunds = {this.state.sourceOfFunds}*/}
                    {/*            placeholder="Select Source Of Funds"*/}
                    {/*            value={this.state.customerAccount.corporateAccountDetails.sourceOfFunds}*/}
                    {/*            onChange={newValue =>*/}
                    {/*                this.onFieldChanged("sourceOfFunds", newValue)*/}
                    {/*            }*/}
                    {/*        />*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Company’s date of incorporation *"
                            required="true">
                            <DatePicker
                                size={"large"}
                                style={{ width: '100%' }}
                                defaultValue={null}
                                value={
                                    this.state.customerAccount.corporateAccountDetails.businessRegistrationDate
                                        ? moment(this.state.customerAccount.corporateAccountDetails.businessRegistrationDate, "DD/MM/YYYY")
                                        : null
                                }
                                placeholder="DD/MM/YYYY"
                                format={"DD/MM/YYYY"}
                                onChange={(newValue, newValueStr) =>
                                    this.onFieldChanged("businessRegistrationDate", newValueStr)
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Registered Address *">
                            <Input
                                size={"large"}
                                value={this.state.customerAccount.corporateAccountDetails.registeredAddress}
                                name="registeredAddress"
                                autoComplete="none"
                                onChange={this.onFormDataChanged}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/*<Row gutter={16}>*/}
                {/*    <Col className="gutter-row" span={12}>*/}
                {/*        <Form.Item*/}
                {/*            label="Registered Address *">*/}
                {/*            <Input*/}
                {/*                value={this.state.customerAccount.corporateAccountDetails.registeredAddress}*/}
                {/*                name="registeredAddress"*/}
                {/*                autoComplete="none"*/}
                {/*                onChange={this.onFormDataChanged}*/}
                {/*            />*/}
                {/*        </Form.Item>*/}
                {/*    </Col>*/}
                {/*    <Col className="gutter-row" span={12}>*/}

                {/*        <Form.Item*/}
                {/*            label="Company Type *">*/}
                {/*            <CompanyTypeSelector*/}
                {/*                placeholder="Select Company Type"*/}
                {/*                value={this.state.customerAccount.corporateAccountDetails.companyType}*/}
                {/*                companyTypes={this.state.companyTypes}*/}
                {/*                onChange={newValue =>*/}
                {/*                    this.onFieldChanged("companyType", newValue)*/}
                {/*                }*/}
                {/*            />*/}
                {/*        </Form.Item>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row gutter={16}>*/}
                {/*    <Col className="gutter-row" span={12}>*/}
                {/*        <Form.Item*/}
                {/*            label="Industry *"*/}
                {/*            required="true">*/}
                {/*            <IndustrySelector style={{width:'100%'}}*/}
                {/*                industries ={this.state.industries}*/}
                {/*                placeholder="Select Industry"*/}
                {/*                value={this.state.customerAccount.corporateAccountDetails.industry}*/}
                {/*                onChange={newValue => this.onFieldChanged("industry", newValue)}*/}
                {/*            />*/}
                {/*        </Form.Item>*/}
                {/*    </Col>*/}

                {/*    <Col className="gutter-row" span={12}>*/}
                {/*        <Form.Item*/}
                {/*            label="Country *"*/}
                {/*            required="true">*/}
                {/*            <BrdgxCountrySelector*/}
                {/*                placeholder="Select Country"*/}
                {/*                name="country"*/}
                {/*                countries={this.state.countries}*/}
                {/*                value={this.state.customerAccount.corporateAccountDetails.country}*/}
                {/*                onChange={*/}
                {/*                    newValue => this.onFieldChanged("country", newValue)*/}
                {/*                }*/}
                {/*            />*/}
                {/*        </Form.Item>*/}
                {/*    </Col>*/}

                {/*</Row>*/}

                <div className="button-wrapper">

                    <Button
                        className="bt-next"
                        type="primary"
                        onClick={this.handleSubmit}>
                        Next
                    </Button>
                </div>
            </div>
            </div>
        );
    }
}

GeneralCorpInfoTab.propTypes = {
    nextTab: PropTypes.func
};

export default GeneralCorpInfoTab;
